import { useEffect, useRef, useState } from 'react';
import { getItemThumbnail } from '../services/api';

/**
 * アイテムIDの配列から、各アイテムのサムネイル署名URL（動画=代表フレーム / PDF=1ページ目）を
 * 遅延取得して map で返す。取得済みIDは再取得しない。
 */
export function useItemThumbnails(ids: string[]): Record<string, string> {
  const [thumbs, setThumbs] = useState<Record<string, string>>({});
  const requested = useRef<Set<string>>(new Set());

  useEffect(() => {
    let alive = true;
    for (const id of ids) {
      if (!id || requested.current.has(id)) continue;
      requested.current.add(id);
      getItemThumbnail(id).then((url) => {
        if (alive && url) setThumbs((m) => ({ ...m, [id]: url }));
      });
    }
    return () => {
      alive = false;
    };
  }, [ids]);

  return thumbs;
}

export default useItemThumbnails;
